import { useState } from "react";
import { useForgotPasswordMutation } from "../../queries/models/_shared/auth.query";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../components/ui/toast-context-provider";
import { motion } from "framer-motion";

export function ForgotPassword() {
  const toast = useToast();
  const [username, setUsername] = useState<string>();

  const mutation = useForgotPasswordMutation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  function executeReset() {
    setIsLoading(true);
    mutation.mutate(
      {
        login: username!,
      },
      {
        onSuccess: (response) => {
          toast.current?.show({
            severity: "success",
            detail: "Check your mailbox for next steps.",
          });
          setTimeout(() => {
            navigate("/");
          }, 2000);
        },
        onError: (error) => {
          toast.current?.show({
            severity: "error",
            detail: error?.toString(),
          });
          console.error(error);
        },
        onSettled: (x, y, z, c) => {
          setIsLoading(false);
        },
      }
    );
  }

  return (
    <div className="surface-300">
      <motion.div
        initial={{ opacity: 0.5 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, ease: "backInOut" }}
        className="absolute flex h-full justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "100%",
          zIndex: 1,
          background:
            "linear-gradient(93deg, rgba(124,77,255,0.5) 39%, rgba(193,163,236,0.05) 81%)",
        }}
      >
        <div
          className="grid grid-nogutter overflow-hidden"
          style={{
            width: "20rem",
            borderRadius: "20px",
            backgroundColor: "white",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          <Card className="w-20rem border-round-2xl">
            <h2 className="mt-1 mb-4 text-center">Forgot password request</h2>
            <div className="mb-2">
              <div
                className="w-full font-semibold mb-1 text-primary"
                style={{}}
              >
                Please enter username or email
              </div>
              <InputText
                id="username"
                className="w-full"
                value={username ?? ""}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => (e.key === "Enter" ? executeReset() : {})}
              />
            </div>
            <Button
              label="Send request"
              loading={isLoading}
              className="bg-primary w-full"
              onClick={executeReset}
              disabled={!username}
            />
          </Card>
        </div>
      </motion.div>
    </div>
  );
}
